<app-menu-common url="hr"></app-menu-common>

@if (hrService.backendMissing()) {
	<div class="hr-backend-warn">Backend RH non déployé : données indisponibles (voir docs/backend-brief-hr.md).</div>
}

<div class="flexrow hr-header">
	<h2>Personnel &amp; rôles</h2>
	<span class="page-hint">Cochez pour donner un rôle ou une mobilité — chaque case est enregistrée aussitôt.</span>
	<span class="spacer"></span>
	<mat-checkbox class="staff-active-filter" [checked]="activeOnly"
		(change)="onActiveToggle($event.checked)"
		matTooltip="Décochez pour afficher aussi les salariés partis (fiche désactivée)">
		Actifs seulement
	</mat-checkbox>
	<mat-form-field class="staff-filter">
		<mat-label>Recherche</mat-label>
		<input matInput (keyup)="applyFilter($event)">
	</mat-form-field>
	<button mat-flat-button color="primary" id="newstaffbutton" (click)="onNew()">
		<mat-icon>person_add</mat-icon>&nbsp;Nouvel employé
	</button>
</div>

<div class="pagecontent">
	<div class="staff-scroll">
		<table class="staff-grid">
			<thead>
				<tr>
					<th class="name-col" rowspan="2">Employé</th>
					<th [attr.colspan]="roles.length" class="group-head" matTooltip="Ce que la personne sait faire. N'ouvre aucun droit — enregistré sur la fiche salarié.">Rôles (métier)</th>
					<th [attr.colspan]="habilitations.length" class="group-head" matTooltip="Ce à quoi la personne a accès dans l'application. Réservé aux administrateurs.">Habilitations</th>
					<th [attr.colspan]="stores.length" class="group-head">Mobilité (peut travailler à…)</th>
					<th rowspan="2" class="link-col"></th>
				</tr>
				<tr>
					@for (r of roles; track r.id) {
						<th class="check-col" [matTooltip]="roleTooltip(r)">{{ r.name }}</th>
					}
					@for (h of habilitations; track h.id) {
						<th class="check-col hr-role" [class.hr-role]="h.id === HR_MANAGER_HABILITATION"
							[matTooltip]="habilitationTooltip(h)">{{ h.name }}</th>
					}
					@for (s of stores; track s.id) {
						<th class="check-col store">{{ s.name }}</th>
					}
				</tr>
			</thead>
			<tbody>
				@for (row of shown; track row.employee.id) {
					<tr [class.saving]="row.saving" [class.inactive]="!row.active">
						<td class="name-col">
							<button type="button" class="name-link"
								[attr.aria-label]="'Fiche de ' + row.name"
								(click)="onOpenEmployee(row)">
								<span class="color-dot" [style.background]="row.color"></span>{{ row.name }}
							</button>
							@if (!row.active) { <span class="gone-chip">Parti</span> }
						</td>
						@for (r of roles; track r.id) {
							<td class="check-col">
								<mat-checkbox [checked]="row.roles.has(r.id!)"
									[disabled]="!canToggleRole(r.id!) || row.saving"
									[matTooltip]="canToggleRole(r.id!) ? '' : roleTooltip(r)"
									(change)="onToggleRole(row, r.id!)"></mat-checkbox>
							</td>
						}
						@for (h of habilitations; track h.id) {
							<td class="check-col hr-role">
								<mat-checkbox [checked]="row.habilitations.has(h.id!)"
									[disabled]="!canToggleHabilitation() || !row.id_user || row.saving"
									[matTooltip]="habilitationTooltip(h)"
									(change)="onToggleHabilitation(row, h.id!)"></mat-checkbox>
							</td>
						}
						@for (s of stores; track s.id) {
							<td class="check-col store">
								<mat-checkbox [checked]="row.mobility.has(s.id!) || isDefaultStore(row, s.id!)"
									[disabled]="!isAdmin || row.saving || isDefaultStore(row, s.id!)"
									[matTooltip]="isDefaultStore(row, s.id!) ? 'Établissement par défaut (voir la fiche)' : ''"
									(change)="onToggleMobility(row, s.id!)"></mat-checkbox>
							</td>
						}
						<td class="link-col">
							<button mat-icon-button matTooltip="Ouvrir la fiche (contrat, PIN, embauche…)" [attr.aria-label]="'Fiche de ' + row.name" (click)="onOpenEmployee(row)">
								<mat-icon>badge</mat-icon>
							</button>
						</td>
					</tr>
				}
				@if (loaded && shown.length === 0) {
					<tr><td [attr.colspan]="2 + roles.length + habilitations.length + stores.length" class="grid-empty">
						@if (hiddenCount) {
							Aucun employé actif — {{ hiddenCount }} fiche{{ hiddenCount > 1 ? 's' : '' }} désactivée{{ hiddenCount > 1 ? 's' : '' }}.
							Décochez « Actifs seulement » pour {{ hiddenCount > 1 ? 'les' : 'la' }} voir.
						} @else {
							Aucun employé. Créez la première fiche avec « Nouvel employé ».
						}
					</td></tr>
				}
			</tbody>
		</table>
	</div>
</div>
